(function () {
  if (window.__PR_LIMITS_STICKY_V2__) return;
  window.__PR_LIMITS_STICKY_V2__ = 1;

  const OFFERS_TAG = 'offerta_settimana';

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root)
    ? Shopify.routes.root
    : '/';

  const withRoot = (p) => {
    if (!p || /^https?:\/\//i.test(p)) return p;
    return ROOT.replace(/\/$/, '') + p;
  };

  const j = (u) => fetch(withRoot(u), { headers: { Accept: 'application/json' } }).then(r => r.json());

  const vCache = new Map();
  const pCache = new Map();

  if (!document.getElementById('pr-toast-limit-sticky-style-v2')) {
    const s = document.createElement('style');
    s.id = 'pr-toast-limit-sticky-style-v2';
    s.textContent = `
      .pr-toast.pr-toast-limit-sticky{
        bottom:160px !important;
        animation: in .55s ease-out forwards !important;
        animation-delay:0s !important;
        white-space:normal !important;
        text-align:center !important;
        line-height:1.25 !important;
        font-size:13px !important;
        min-width:280px;
        max-width:340px;
      }
      .pr-toast.pr-toast-limit-sticky .pr-line1{display:block;font-weight:700;}
      .pr-toast.pr-toast-limit-sticky .pr-line2{display:block;font-weight:600;}
    `;
    document.head.appendChild(s);
  }

  function __prIsMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function __prIsQuickOpen() {
    return !!document.querySelector('#halo-cart-sidebar.is-open,#halo-cart-sidebar.open,.halo-sidebar.is-open,body.cart-sidebar-show');
  }

  function ensureStickyToast() {
    let el = document.getElementById('prLimitSticky');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pr-toast pr-toast-limit-sticky';
      el.id = 'prLimitSticky';
      document.body.appendChild(el);
    }
    return el;
  }

  function hideStickyToast() {
    const el = document.getElementById('prLimitSticky');
    if (el) el.remove();
  }

  function getHandleFromUrl(url) {
    try {
      const u = new URL(url, location.origin);
      const m = u.pathname.match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function getHandleFromCartItem(it) {
    return it.handle || getHandleFromUrl(it.url || '');
  }

  function getHandleFromForm(form) {
    const link = form.closest('li,div,section,article')?.querySelector('a[href*="/products/"]');
    if (link) return getHandleFromUrl(link.getAttribute('href'));

    if (location.pathname.includes('/products/')) {
      return getHandleFromUrl(location.pathname);
    }

    return '';
  }

  function hasOfferTag(product) {
    const raw = product && product.tags ? product.tags : [];
    const tags = Array.isArray(raw) ? raw : String(raw).split(',');
    return tags.map(t => String(t).trim().toLowerCase()).includes(OFFERS_TAG.toLowerCase());
  }

  async function productByHandle(handle) {
    if (!handle) return null;
    if (pCache.has(handle)) return pCache.get(handle);

    const p = await j(`/products/${handle}.js`);
    pCache.set(handle, p);
    return p;
  }

  async function isOfferVariant(variantId, handle) {
    const p = await productByHandle(handle);
    if (!p) return false;

    const variantExists = (p.variants || []).some(v => +v.id === +variantId);
    return variantExists && hasOfferTag(p);
  }

  async function offersSet(cart) {
    cart = cart || await j('/cart.js');
    const ids = [];

    for (const it of (cart.items || [])) {
      const handle = getHandleFromCartItem(it);
      if (await isOfferVariant(+it.variant_id, handle)) {
        ids.push(+it.variant_id);
      }
    }

    return new Set(ids);
  }

  async function vInfo(id) {
    id = +id;
    if (vCache.has(id)) return vCache.get(id);

    const v = await j(`/variants/${id}.js`);
    const max = (+v.weight > 2000) ? 2 : 3;

    const title =
      (v.product_title || ((window.PR_I18N && window.PR_I18N.limits && window.PR_I18N.limits.product) || 'Product')) +
      (v.public_title && v.public_title !== 'Default Title' ? ` - ${v.public_title}` : '');

    const out = { max, title };
    vCache.set(id, out);
    return out;
  }

  function titleFromCartItem(it) {
    if (!it) return ((window.PR_I18N && window.PR_I18N.limits && window.PR_I18N.limits.product) || 'Product');

    return it.variant_title && it.variant_title !== 'Default Title'
      ? `${it.product_title} - ${it.variant_title}`
      : it.product_title;
  }

  async function getOverLimitState(cart, set) {
    cart = cart || await j('/cart.js');
    set = set || await offersSet(cart);

    const over = [];

    for (const it of (cart.items || [])) {
      const vid = +it.variant_id;
      if (!set.has(vid)) continue;

      const info = await vInfo(vid);

      if (+it.quantity > info.max) {
        over.push({
          vid,
          max: info.max,
          title: titleFromCartItem(it),
          qty: +it.quantity
        });
      }
    }

    return over;
  }

  function prTxt(key) {
    try {
      return (window.PR_I18N && window.PR_I18N.limits && window.PR_I18N.limits[key]) || '';
    } catch (e) {
      return '';
    }
  }

  function prTpl(str, vars) {
    return String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => (vars && vars[k] != null ? vars[k] : ''));
  }

  function renderSticky(over) {
    if (__prIsMobile() && __prIsQuickOpen()) {
      hideStickyToast();
      return;
    }

    if (!over || over.length === 0) return hideStickyToast();

    const el = ensureStickyToast();

    if (over.length === 1) {
      const o = over[0];
      const line1 = prTpl(prTxt('cannot_more_than'), { max: o.max });

      el.innerHTML =
        `<span class="pr-line1">${line1}</span>` +
        `<span class="pr-line2">${o.title}</span>`;
    } else {
      el.innerHTML =
        `<span class="pr-line1">${prTxt('multiple_over_1')}</span>` +
        `<span class="pr-line2">${prTxt('multiple_over_2')}</span>`;
    }
  }

  function updateCheckoutButton(over) {
    const buttons = document.querySelectorAll(
      '#cart-sidebar-checkout, .cart-actions button[name="checkout"], .pr-top-checkout'
    );

    if (!buttons.length) return;
    if (window.__PR_WEIGHT_OVER_LIMIT__ === true) return;

    const on = Array.isArray(over) && over.length > 0;

    function isBadText(txt) {
      txt = String(txt || '').trim().toLowerCase();

      return (
        txt === 'order not valid' ||
        txt === 'limiti superati' ||
        txt === 'limits exceeded' ||
        txt === 'limites superados' ||
        txt === 'limites dépassées' ||
        txt === 'límites superados'
      );
    }

    function normalText(btn) {
      if (btn.dataset.prOrigTxt && !isBadText(btn.dataset.prOrigTxt)) {
        return btn.dataset.prOrigTxt;
      }

      if (btn.id === 'cart-sidebar-checkout') {
        return 'VAI AL PAGAMENTO';
      }

      return 'PROCEDI AL CHECKOUT';
    }

    function setBlocked(btn) {
      btn.textContent = prTxt('checkout_over') || 'Limiti superati';
      btn.style.backgroundColor = '#E53935';
      btn.style.color = '#fff';
      btn.disabled = true;
      btn.setAttribute('disabled', 'disabled');
      btn.setAttribute('aria-disabled', 'true');
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.9';
    }

    function setNormal(btn) {
      btn.textContent = normalText(btn);
      btn.style.backgroundColor = btn.dataset.prOrigBg || '';
      btn.style.color = btn.dataset.prOrigColor || '';
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.setAttribute('aria-disabled', 'false');
      btn.style.pointerEvents = 'auto';
      btn.style.opacity = '1';
    }

    buttons.forEach(btn => {
      const currentText = (btn.textContent || '').trim();

      if (!btn.dataset.prOrigBg) {
        btn.dataset.prOrigBg = getComputedStyle(btn).backgroundColor || '';
        btn.dataset.prOrigColor = getComputedStyle(btn).color || '';
      }

      if (!btn.dataset.prOrigTxt && !isBadText(currentText)) {
        btn.dataset.prOrigTxt = currentText;
      }

      if (on) {
        setBlocked(btn);
      } else {
        setNormal(btn);
        setTimeout(() => setNormal(btn), 80);
        setTimeout(() => setNormal(btn), 220);
        setTimeout(() => setNormal(btn), 500);
      }
    });
  }

  async function disablePlusAtMax(cart, set) {
    cart = cart || await j('/cart.js');
    set = set || await offersSet(cart);

    for (const it of (cart.items || [])) {
      const vid = +it.variant_id;
      if (!set.has(vid)) continue;

      const info = await vInfo(vid);
      if (+it.quantity < info.max) continue;

      document.querySelectorAll(`cart-update-quantity[data-variant="${vid}"] a.plus, cart-update-quantity[data-variant="${vid}"] [data-plus-quantity-cart]`)
        .forEach(b => {
          b.style.pointerEvents = 'none';
          b.style.opacity = '0.45';
        });

      document.querySelectorAll(`[data-cart-quantity-id="${vid}"]`)
        .forEach(inp => {
          const wrap = inp.closest('cart-update-quantity,.cart-item,.line-item,tr,li,div') || inp;
          wrap.querySelectorAll('.btn-quantity.plus,[data-plus-quantity-cart],a.plus,button[aria-label="+"]')
            .forEach(b => {
              b.style.pointerEvents = 'none';
              b.style.opacity = '0.45';
            });
        });
    }
  }

  let tmr = null;
  let isRefreshing = false;
  let pendingRefresh = false;
  let lastRefresh = 0;

  async function refresh() {
    if (isRefreshing) {
      pendingRefresh = true;
      return;
    }

    const now = Date.now();
    if (now - lastRefresh < 120) {
      schedule(120);
      return;
    }

    isRefreshing = true;
    lastRefresh = now;

    try {
      const cart = await j('/cart.js');
      const set = await offersSet(cart);
      const over = await getOverLimitState(cart, set);

      renderSticky(over);

      if (typeof markOverLimit === 'function') {
        markOverLimit(over);
      }

      updateCheckoutButton(over);
      await disablePlusAtMax(cart, set);
    } catch (e) {
    } finally {
      isRefreshing = false;

      if (pendingRefresh) {
        pendingRefresh = false;
        schedule(100);
      }
    }
  }

  function schedule(ms = 80) {
    clearTimeout(tmr);
    tmr = setTimeout(refresh, ms);
  }

  function fastRefresh() {
    schedule(20);
    setTimeout(refresh, 120);
    setTimeout(refresh, 320);
    try { if (window.prRefreshCart) window.prRefreshCart(); } catch (e) {}
  }

  // ===== PR · hook di rete: reagisci SUBITO a ogni add/change/update/clear, anche AJAX dai blocchi custom (es. prodotto su video) =====
  (function () {
    const RE = /\/cart\/(add|change|update|clear)/;
    const _f = window.fetch;
    window.fetch = function () {
      const u = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      const p = _f.apply(this, arguments);
      if (RE.test(u)) { p.then(function (r) { if (r && r.ok) fastRefresh(); }).catch(function () {}); }
      return p;
    };
    const _o = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) { this.__pru = u; return _o.apply(this, arguments); };
    const _s = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      this.addEventListener('loadend', function () { if (RE.test(this.__pru || '')) fastRefresh(); });
      return _s.apply(this, arguments);
    };
  })();

  document.addEventListener('click', async (e) => {
    const form = e.target.closest('form[action^="/cart/add"]');
    if (!form) return;

    const id = form.querySelector('input[name="id"]')?.value;
    if (!id) return;

    const handle = getHandleFromForm(form);
    const isOffer = await isOfferVariant(+id, handle);
    if (!isOffer) return;

    const addQty = +(form.querySelector('input[name="quantity"]')?.value || 1);

    const [cart, info] = await Promise.all([j('/cart.js'), vInfo(id)]);
    const cur = (cart.items || []).find(i => +i.variant_id === +id)?.quantity || 0;

    if (cur + addQty > info.max) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!(__prIsMobile() && __prIsQuickOpen())) {
        const el = ensureStickyToast();
        const line1 = prTpl(prTxt('cannot_more_than'), { max: info.max });

        el.innerHTML =
          `<span class="pr-line1">${line1}</span>` +
          `<span class="pr-line2">${info.title}</span>`;
      }

      updateCheckoutButton([{ max: info.max, title: info.title }]);
      fastRefresh();
    }
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target.closest(
      'cart-update-quantity a.plus,' +
      'cart-update-quantity a.minus,' +
      '.btn-quantity,' +
      '[data-plus-quantity-cart],' +
      '[data-minus-quantity-cart],' +
      '[data-cart-remove]'
    )) {
      fastRefresh();
    }
  }, true);

  document.addEventListener('change', (e) => {
    if (e.target.matches('input.quantity,[data-cart-quantity-id]')) {
      fastRefresh();
    }
  }, true);

  ['cart:build', 'cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, function () { schedule(20); });
  });

  new MutationObserver(() => schedule(250))
    .observe(document.documentElement, { subtree: true, childList: true });

  schedule(250);
})();

(function () {
  const isCartPage = location.pathname === '/cart';
  const isQuickCartOpen = () =>
    document.querySelector('#halo-cart-sidebar.is-open,#halo-cart-sidebar.open,.halo-sidebar.is-open,body.cart-sidebar-show');

  function hideMinmaxify() {
    if (isCartPage || isQuickCartOpen()) return;
    document.querySelectorAll('[id*="minmax"],[class*="minmax"],[data-minmax]').forEach(el => el.remove());
  }

  new MutationObserver(hideMinmaxify).observe(document.documentElement, { subtree: true, childList: true });
  hideMinmaxify();
})();

if (!document.getElementById('pr-overlimit-style')) {
  const s = document.createElement('style');
  s.id = 'pr-overlimit-style';
  s.textContent = `
    .pr-overlimit{
      outline:2px solid #E53935 !important;
      outline-offset:2px !important;
      border-radius:0 !important;
    }
  `;
  document.head.appendChild(s);
}

function markOverLimit(over) {
  document.querySelectorAll('.pr-overlimit').forEach(el => el.classList.remove('pr-overlimit'));

  (over || []).forEach(o => {
    const vid = +o.vid;
    if (!vid) return;

    document.querySelectorAll(`cart-update-quantity[data-variant="${vid}"]`)
      .forEach(el => el.classList.add('pr-overlimit'));

    document.querySelectorAll(`[data-cart-quantity-id="${vid}"]`)
      .forEach(inp => {
        const wrap = inp.closest('cart-update-quantity,.cart-item,.line-item,tr,li,div');
        (wrap || inp).classList.add('pr-overlimit');
      });

    document.querySelectorAll(`[data-variant-id="${vid}"],[data-variantid="${vid}"]`)
      .forEach(el => el.classList.add('pr-overlimit'));
  });
}